<template>
  <el-container class="box">
    <el-header class="title" style="height: auto">项目</el-header>
    <el-main style="padding-top:10px">
      <el-row :gutter="20">
        <el-col :span="8" class="bg-border">
          <div class="sub-title">{{ countProject }}</div>
          <div class="sub-description">项目</div>
        </el-col>
        <el-col :span="8" class="bg-border">
          <div class="sub-title">{{ countDept }}</div>
          <div class="sub-description">单位</div>
        </el-col>
        <el-col :span="8" class="bg-border last-border">
          <div class="sub-title">{{ countPerson }}</div>
          <div class="sub-description">人次</div>
        </el-col>
      </el-row>
      <div class="sub-description margin-vert">项目类型统计图</div>
      <div id="main" class="chart-border" :style="{ height: '72px', width: '100%' }"></div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      countProject: 0,
      countDept: 0,
      countPerson: 0,
      option: {
        xAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {fontSize: 8},
            color: '#e2e9ff'
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: [],
          max: 'dataMax',
          axisLabel: {'interval': 0, rotate: 10, textStyle: {fontSize: 8}, color: '#e2e9ff'}
        },
        grid: {
          top: 10,
          bottom: 20,
          left: 80,
          right: 40
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)', opacity: '0.5'
            },
            label: {
              show: true,
              position: 'right',
              valueAnimation: true,
              textStyle: {
                fontSize: 8
              }
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                offset: 0,
                color: '#00A2FF' // 0% 处的颜色
              }, {
                offset: 1,
                color: '#00CCD2' // 100% 处的颜色
              }], false),
              borderRadius: 22
            }
          }
        ]
      }
    }
  },
  created () {
    this.fetchCountData();
    this.fetchTypeData();
  },
  methods: {
    fetchCountData () {
      this.post('/dataapi/open/nqi/fruit/countProject').then(res => {
        this.countProject = res.result;
      });
      this.post('/dataapi/open/nqi/fruit/countProjectUnit').then(res => {
        this.countDept = res.result;
      });
      this.post('/dataapi/open/nqi/fruit/countPeopleSum').then((res) => {
        this.countPerson = res.result;
      });
    },
    fetchTypeData () {
      this.post('/dataapi/open/nqi/fruit/getProjectCountByType').then(res => {
        let dom = document.getElementById('main');
        let typeData = [];
        let rsData = [];
        for (let index in res.result) {
          typeData.splice(index, 1, res.result[index].project_type)
          rsData.splice(index, 1, res.result[index].rs)
        }
        this.option.yAxis.data = typeData;
        this.option.series[0].data = rsData;
        let chart = echarts.init(dom);
        chart.setOption(this.option);
      });
    }
  }
}
</script>

<style lang="less" scoped>
.box{
  background-image: url('../assets/images/contentBg-min.png');
  background-size: 100% 100%;
  width: 100%;
  height: 242px;
}
.title{
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #00FFF4;
  margin: 16px auto 0;
}
.sub-title{
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  color: #00FFF4;
  margin: 2px auto 0;
  text-align: center;
  font-size: 22px;
}
.sub-description{
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  color: #FFFFFF;
  margin: 2px auto 0;
  text-align: center;
  font-size: 12px;
}
.bg-border{
  background-image: url('../assets/images/bg-border.png');
  background-size: 100% 100%;
  width: 30%;
  height: 56px;
  padding: 1px 0 0 20px;
  margin-right: 5%;
}
.last-border{
  margin-right: 0;
}
.margin-vert{
  margin: 15px auto 10px;
}
.chart-border{
  background-image: url('../assets/images/bg-border.png');
  background-size: 100% 100%;
  width: 100%;
  height: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/projectCount.vue